import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/components/Common'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: () => import('@/views/home/index'),
      },
      {
        path: '/about', //关于我们
        component: () => import('@/views/aboutUs/index'),
      },
      {
        path: '/about/details', //新闻详情
        component: () => import('@/views/aboutUs/details'),
      },
      {
        path: '/product',
        component: () => import('@/views/product/index'),
        meta: {
          keepAlive: false
        },
      },
      {
        path: '/scheme',
        component: () => import('@/views/scheme/index'),
        meta: {
          keepAlive: false
        },
      },
      {
        path: '/case',
        component: () => import('@/views/userCase/index'),
      },
      {
        path: '/case/details',
        component: () => import('@/views/userCase/details'),
      },
      {
        path: '/scene',
        component: () => import('@/views/useScene/index'),
      },
      {
        path: '/service',
        component: () => import('@/views/serviceAndSupport/index'),
      },
    ]
  },
  {
    path: '/admin',
    component: () => import('@/views/admin/login/login'),
  },
  {
    path: '/index',
    component: () => import('@/views/admin/login/index'),
    redirect: '/baseSet',
    children: [
      {
        path: '/baseSet',
        component: () => import('@/views/admin/baseSet/index'),
      },
      {
        path: '/newsManage',
        component: () => import('@/views/admin/newsManage/index'),
      },
      {
        path: '/newsManage/publish',
        component: () => import('@/views/admin/newsManage/publish'),
      },
      // 产品-方案列表
      {
        path: '/proAndScheme',
        component: () => import('@/views/admin/proAndScheme/index'),
      },
      // 产品/方案详情
      {
        path: '/proAndScheme/details',
        component: () => import('@/views/admin/proAndScheme/details'),
      },
      {
        path: '/caseManage',
        component: () => import('@/views/admin/caseManage/index'),
      },
      {
        path: '/caseManage/publish',
        component: () => import('@/views/admin/caseManage/publish'),
      },
      {
        path: '/sceneManage',
        component: () => import('@/views/admin/sceneManage/index'),
      },
      {
        path: '/sceneManage/publish',
        component: () => import('@/views/admin/sceneManage/publish'),
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 每次路由跳转页面回到首部
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;

  // 兼容IE
  window.scrollTo(0, 0);
  next();
})

// 解决 vue-router3.0 及以上版本回调形式改成Promise API的形式了，返回的是一个Promise，由地址跳转相同，且没有捕获到错误，控制台始终会出现上图所出现的问题。​
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location){
return originalPush.call(this , location).catch(err=>err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location){
return originalReplace.call(this , location).catch(err=>err)
}


export default router
